class NestedFilters extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)

    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  mergeCurrentQueryInto (href) {
    const nextUrl = new URL(href, window.location.origin)
    const currentSearchParams = new URLSearchParams(window.location.search)

    currentSearchParams.forEach((paramValue, paramName) => {
      if (!nextUrl.searchParams.has(paramName)) {
        nextUrl.searchParams.append(paramName, paramValue)
      }
    })

    if (nextUrl.searchParams.has('page')) {
      nextUrl.searchParams.set('page', '1')
    }

    return nextUrl.toString()
  }

  buildAvailabilityMap (dom) {
    const availabilityMap = new Map()
    const normalizeValue = (value) =>
      (value || '').toString().trim().toLowerCase()

    const addAvailableValue = (paramName, paramValue) => {
      if (!paramName || !paramValue) return
      if (!paramName.startsWith('filter.')) return

      if (!availabilityMap.has(paramName)) {
        availabilityMap.set(paramName, new Set())
      }

      availabilityMap.get(paramName).add(normalizeValue(paramValue))
    }

    dom.querySelectorAll('input[name^="filter."][value]').forEach((element) => {
      addAvailableValue(element.getAttribute('name'), element.value)
    })

    dom.querySelectorAll('select[name^="filter."]').forEach((selectEl) => {
      selectEl.querySelectorAll('option[value]').forEach((optionEl) => {
        addAvailableValue(selectEl.getAttribute('name'), optionEl.value)
      })
    })

    dom
      .querySelectorAll('[data-filter-name][data-filter-value]')
      .forEach((element) => {
        addAvailableValue(
          element.getAttribute('data-filter-name'),
          element.getAttribute('data-filter-value'),
        )
      })

    return availabilityMap
  }

  pruneUnavailableFilters (href, dom, dropIfFacetMissing = true) {
    const url = new URL(href, window.location.origin)
    const searchParams = new URLSearchParams(url.search)
    const availabilityMap = this.buildAvailabilityMap(dom)
    const normalizeValue = (value) =>
      (value || '').toString().trim().toLowerCase()

    let wasMutated = false

    Array.from(searchParams.keys())
      .filter((paramName) => paramName.startsWith('filter.'))
      .forEach((paramName) => {
        const activeValues = searchParams.getAll(paramName)
        if (!activeValues.length) return

        const availableValuesSet = availabilityMap.get(paramName)

        if (!availableValuesSet) {
          if (dropIfFacetMissing) {
            searchParams.delete(paramName)
            wasMutated = true
          }
          return
        }

        const validValues = activeValues.filter((value) =>
          availableValuesSet.has(normalizeValue(value)),
        )

        if (validValues.length !== activeValues.length) {
          searchParams.delete(paramName)
          validValues.forEach((value) => searchParams.append(paramName, value))
          wasMutated = true
        }
      })

    if (!wasMutated) return href

    if (searchParams.has('page')) searchParams.set('page', '1')

    url.search = searchParams.toString()
    return url.toString()
  }

  async handleTrigger (event) {
    const trigger = event.target.closest('[data-trigger]')

    if (!trigger) return

    event.preventDefault()

    const mainGrid = document.querySelector('[data-nested-filters-el="grid')

    mainGrid.setAttribute('aria-busy', true)

    const sectionId = document.querySelector('#collection-template').dataset
      .sectionId

    const mergedHref = this.mergeCurrentQueryInto(trigger.href)

    window.history.pushState({}, '', mergedHref)

    await window.BAO.sectionRenderer
      .fetchSingle(sectionId, mergedHref)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const cleanedHref = this.pruneUnavailableFilters(
          mergedHref,
          newDOM,
          true,
        )

        if (cleanedHref !== mergedHref) {
          return window.BAO.sectionRenderer
            .fetchSingle(sectionId, cleanedHref)
            .then((res2) => {
              const dom = window.BAO.sectionRenderer.convertToDOM(res2)

              const bannerTempEl = dom.querySelector(
                '[data-nested-filters-el="banner"]',
              )
              const bannerEl = document.querySelector(
                '[data-nested-filters-el="banner"]',
              )
              bannerEl.replaceWith(bannerTempEl)

              const gridTempEl = dom.querySelector(
                '[data-nested-filters-el="grid-body"]',
              )
              const gridEl = document.querySelector(
                '[data-nested-filters-el="grid-body"]',
              )
              gridEl.replaceWith(gridTempEl)

              const headerClass = gridTempEl.dataset.headerClass
              document.body.classList = ''
              document.body.classList = headerClass

              const activeTempEl = dom.querySelector(
                '[data-nested-filters-el="active"]',
              )
              const activeEl = document.querySelector(
                '[data-nested-filters-el="active"]',
              )
              activeEl.replaceWith(activeTempEl)

              const countTempEl = dom.querySelector(
                '[data-nested-filters-el="count"]',
              )
              const countEl = document.querySelector(
                '[data-nested-filters-el="count"]',
              )
              countEl.replaceWith(countTempEl)

              const filtersMobileTempEl = dom.querySelector(
                '[data-nested-filters-el="filters-mobile"]',
              )
              const filtersMobileEl = document.querySelector(
                '[data-nested-filters-el="filters-mobile"]',
              )
              filtersMobileEl.replaceWith(filtersMobileTempEl)

              window.history.replaceState({}, '', cleanedHref)

              mainGrid.setAttribute('aria-busy', false)
            })
        }

        const bannerTempEl = newDOM.querySelector(
          '[data-nested-filters-el="banner"]',
        )
        const bannerEl = document.querySelector(
          '[data-nested-filters-el="banner"]',
        )
        bannerEl.replaceWith(bannerTempEl)

        const gridTempEl = newDOM.querySelector(
          '[data-nested-filters-el="grid-body"]',
        )
        const gridEl = document.querySelector(
          '[data-nested-filters-el="grid-body"]',
        )
        gridEl.replaceWith(gridTempEl)

        const headerClass = gridTempEl.dataset.headerClass
        document.body.classList = ''
        document.body.classList = headerClass

        const activeTempEl = newDOM.querySelector(
          '[data-nested-filters-el="active"]',
        )
        const activeEl = document.querySelector(
          '[data-nested-filters-el="active"]',
        )
        activeEl.replaceWith(activeTempEl)

        const countTempEl = newDOM.querySelector(
          '[data-nested-filters-el="count"]',
        )
        const countEl = document.querySelector(
          '[data-nested-filters-el="count"]',
        )
        countEl.replaceWith(countTempEl)

        const filtersMobileTempEl = newDOM.querySelector(
          '[data-nested-filters-el="filters-mobile"]',
        )
        const filtersMobileEl = document.querySelector(
          '[data-nested-filters-el="filters-mobile"]',
        )
        filtersMobileEl.replaceWith(filtersMobileTempEl)

        mainGrid.setAttribute('aria-busy', false)
      })
      .catch(() => {
        return null
      })
  }
}

if (!customElements.get('nested-filters')) {
  customElements.define('nested-filters', NestedFilters)
}
